import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { genURL, INSCorServicePostTest } from '../_getjson.js';
import SelectFix from './SelectFix';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Grid from '@mui/material/Grid';
require('./../_css/PopUpOther.css');

export const ReDate = (TimeStamp) => {
    var myDate = new Date(TimeStamp);
    var date = (myDate.getDate() < 10 ? '0' : '') + (myDate.getDate());
    var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
    var year = myDate.getFullYear() + 543;
    return date + "/" + month + "/" + year;
}

export const startdate = () => {
    var myDate = new Date();
    var date = "01"
    var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
    var year = myDate.getFullYear() + 543;
    return date + "/" + month + "/" + year;
}
export const ReDate2 = (date) => {
    var dateSp = date.split("/");
    var dataRe = dateSp[2] - 543 + "-" + dateSp[1] + "-" + dateSp[0];
    return dataRe
}
const mystyle = {
    paddingTop: '0px',
    // paddingLeft:'0px'
};
export default class PopUpSearch_transfer extends React.Component {
    constructor(props) {
        super(props);
        this.DOCNO1 = React.createRef();
        this.DOCNO2 = React.createRef();
        this.DOCGROUP = React.createRef();
        this.itemlist = React.createRef();
        this.state = {
            rows: [],
            Htext: '',
            _from: '',
            openBackdrop: false,
            DATE1: startdate(),
            DATE2: '',
        }
    }
    componentDidMount() {
        this.setState({ _from: this.props.from });
        setTimeout(() => {
            this.onSearch();
        }, 200);

    }

    onClose = (e) => {
        this.props.closePopup();
    }
    ViewCSTV = (DATA) => {
        switch (DATA) {
            case "CSSTKMOVEREQ": this.setState({ Htext: "บันทึกใบขอโอนสินค้า" }); return "CSSTKMOVEREQ/Search?";
            case "CSSTKMOVE": this.setState({ Htext: "บันทึกใบโอนสินค้า" }); return "CSSTKMOVE/Search?";
            // case "CSARDEPOSIT": this.setState({Htext:"บันทึกรับเงินล่วงหน้า/เงินมัดจำ"});   return "CSARDEPOSIT/SEARCH"; break;
            default: break;
        }
    }
    onSearch = async (e) => {
        this.setState({ openBackdrop: true })
        var url = this.ViewCSTV(this.props.from);
        /* var url = "http://Localhost:8080/Search?"; */
        /* url += "?SITECODE="+this.props.userSite; */
        url += "&DATE1=" + ReDate2(this.state.DATE1);
        url += "&DATE2=" + ReDate2(this.state.DATE2);
        url += "&DOCNO1=" + this.DOCNO1.current.value;
        url += "&DOCNO2=" + this.DOCNO2.current.value;
        // url += "&ARCODE="+this.ARCODE.current.value;
        // url += "&APCODE="+this.APCODE.current.value;
        url += "&DOCGROUP=" + this.DOCGROUP.current.value;
        url += "&TOP=" + this.itemlist.current.value;
        /* INSCorServicePostTest(url).then(res => { */
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
            // console.log("::::::::::::::::::::::"+res);
            if (res.data.length > 0) {
                var data = [];
                for (var i = 0; i < res.data.length; i++) {
                    data[i] = {
                        C0: i + 1,
                        C1: ReDate(res.data[i].DOCDATE),
                        C2: res.data[i].DOCNO,
                        C3: res.data[i].REMARK,

                    }
                    // if(res.data[i].APCODE){
                    //     data[i].C3 = res.data[i].APCODE;
                    //     data[i].C4 = res.data[i].APNAME;
                    //     data[i].C5 = res.data[i].REMARK;                 
                    // }
                    if (i === res.data.length - 1) {
                        this.setState({ rows: data });
                        this.setState({ openBackdrop: false })
                    }
                }
            } else {
                this.setState({ rows: data });
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ openBackdrop: false })
        });
    }
    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "Calendar1": this.setState({ DATE1: data2 }); break;
            case "Calendar2": this.setState({ DATE2: data2 }); break;
            default: break;
        }
    }
    onSelectRow = (data) => {
        this.props.Get_Popup(data);
        this.props.closePopup();
    }
    KeyUp = (e) => {
        switch (e.target.id) {
            case "DOCNO1":
                this.DOCNO2.current.value = e.target.value;
                break;
            default:
                break;
        }
        // console.log(e.key);
        if (e.key === "Enter") {
            this.onSearch();
        }
    }
    render() {
        return (
            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search"> {this.state.Htext}  </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="right">
                        <Grid container spacing={2}>
                            <Grid item xs={6} >
                                <MaterialUIPickers title="วันที่"
                                    DateValue={e => this.SelectSetData("Calendar1", e)}
                                    defaultdate={this.state.DATE1}
                                    Popup={true} />
                            </Grid>
                            <Grid item xs={6}>

                                <MaterialUIPickers title="ถึง"
                                    DateValue={e => this.SelectSetData("Calendar2", e)}
                                    defaultdate={this.state.DATE2}
                                    Popup={true} />

                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> ใบขอโอน : </span>
                                        <input type="text" className="form-control" id="DOCNO1" ref={this.DOCNO1} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">ถึง : </span>
                                        <input type="text" className="form-control" id="DOCNO2" ref={this.DOCNO2} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> กลุ่มข้อมูล : </span>
                                        <input type="text" className="form-control" id="DOCGROUP" ref={this.DOCGROUP} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">จำนวนรายการ : </span>
                                        <input type="text" className="form-control" id="itemlist" ref={this.itemlist} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <button className="PUSDbtn" onClick={this.onSearch.bind(null)}><i className="fas fa-search" > ค้นหา </i></button>
                        <div className="DivTable">
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูล"
                                }}
                                height='650'
                                hover condensed>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="30" dataField='C0' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="20%" dataField='C1'> วันที่เอกสาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="20%" dataField='C2'> เลขที่เอกสาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="60%" dataField='C3'> หมายเหตุ </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
